module.exports = __webpack_public_path__ + "img/banner_left.e458c7c2.png";